import React from 'react';

const NewShopIcon: React.FC = () => {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_7794_54786)'></g>
      <rect
        x='0.75'
        y='3.23779'
        width='18.5'
        height='14.5'
        rx='2.25'
        stroke='#C7C6CF'
        strokeWidth='1.5'
      />
      <path
        d='M7.11765 12.9878H6.12941L4.02941 10.0711V12.9878H3V7.98779H4.02941L6.08824 10.9045V7.98779H7.11765V12.9878Z'
        fill='#C7C6CF'
      />
      <path
        d='M11.2353 9.03779H9.17647V9.97113H11.2353V11.0211H9.17647V11.9461H11.2353V12.9878H7.94118V7.98779H11.2353V9.03779Z'
        fill='#C7C6CF'
      />
      <path
        d='M17 12.1545C17 12.6128 16.6294 12.9878 16.1765 12.9878H12.8824C12.4294 12.9878 12.0588 12.6128 12.0588 12.1545V7.98779H13.0882V11.7461H14.0188V8.81279H15.0482V11.7378H15.9706V7.98779H17V12.1545Z'
        fill='#C7C6CF'
      />
      <defs>
        <clipPath id='clip0_7794_54786'>
          <rect y='2.48779' width='20' height='16' rx='3' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NewShopIcon;
